export const intakeEndpoints = {
  prefillIntakeForm: { method: 'get', path: '/{intakeFormId}/prefill' },
  listDraftIntakeSubmissions: { method: 'get', path: '/drafts' },
  getDraftIntakeSubmission: { method: 'get', path: '/drafts/{draftIntakeId}' },
  insertDraftIntakeSubmission: { method: 'post', path: '/drafts' },
  updateDraftIntakeSubmission: { method: 'post', path: '/drafts/{draftIntakeId}' },
  deleteDraftIntakeSubmission: { method: 'post', path: '/drafts/{draftIntakeId}/delete' },
  generateIntakeFormReview: { method: 'post', path: '/drafts/{draftIntakeId}/generate-review' },
  updateFormReviewIssueStatus: { method: 'post', path: '/form-review-issues/{formReviewIssueId}' },
  formReviewIssueFeedback: { method: 'post', path: '/form-review-issues/{formReviewIssueId}/feedback' },
  reviewDocument: { method: 'post', path: '/review-document' },
  getDocumentReview: { method: 'get', path: '/review/{documentReviewId}' },
} as const
